/**
 * Magen quick-add
 *
 * Wires the plus button on .magen-product-tile to POST a single quantity
 * of the product's first available variant to /cart/add.js. Dispatches a
 * CustomEvent('cart:refresh') so Horizon's cart drawer can refresh.
 *
 * Delegated from document so it works for tiles rendered by any section.
 */
(function () {
  if (window.__magenQuickAddBound) return;
  window.__magenQuickAddBound = true;

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('.magen-product-tile__quick-add');
    if (!button) return;

    event.preventDefault();
    event.stopPropagation();

    const variantId = button.dataset.variantId;
    if (!variantId) return;
    if (button.dataset.loading === 'true') return;

    button.dataset.loading = 'true';
    button.setAttribute('aria-busy', 'true');

    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] }),
      });

      if (!response.ok) {
        const error = await response.json().catch(() => ({}));
        console.error('Magen quick-add failed', error);
        return;
      }

      // Horizon's cart drawer + cart icon listen for "cart:update".
      document.dispatchEvent(
        new CustomEvent('cart:update', {
          bubbles: true,
          detail: { source: 'magen-quick-add' },
        })
      );
    } finally {
      button.dataset.loading = 'false';
      button.removeAttribute('aria-busy');
    }
  });
})();
